import React from 'react';
import { Navigate } from 'react-router-dom';
import { isLoggedIn } from "utils/authservice";
import RoutePaths from "../../utils/RoutePaths";

const PrivateRoute = ({ children }) => {
  if (isLoggedIn()) {
    return children;
  }
  return <Navigate to={RoutePaths.login} replace />;
};

export default PrivateRoute;
